<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
      <div class="" v-if="product_info">
        <p>نام محصول: {{product_info.name}}</p>
        <p>قیمت محصول:
          {{formatNumber(product_info.price)}}</p>
      </div>
    </div>
    <b-form-checkbox
        class="my-2"
        :checked="item.config && item.config.skip_address"
        @change="toggleSkipAddress"
        switch
    >
      بدون آدرس (فرم تنها)
    </b-form-checkbox>

    <!--  انتخاب محصول  -->
    <b-button class="btn btn-sm" v-b-modal="`choose-product-${item.id}`">انتخاب محصول</b-button>

    <b-modal :id="`choose-product-${item.id}`" hide-footer :ref="`choose-product-${item.id}`">
      <div class="" dir="rtl">
        <form @submit.prevent="">
          <b-form-input placeholder="جست و جو در محصولات" v-model="searchOnProduct" @keyup.enter="searchProducts"/>
          <b-col cols="12" class="text-center w-100 px-2 py-3 overflow-manager rounded">
            <div v-for="(product,index) in products" :key="index">
              <div v-for="(sub_product,index) in subProducts(product)" :key="index*2">

                <span @click="addProduct(sub_product,product)" class="selected_item cursor_pointer p-2 ml-2 rounded">
                    {{ productName(product, sub_product.id) }}
                </span>
                <hr class="text-secondary w-100">

              </div>

            </div>
            <p v-if="products.length==0" class="text-center">هیچ محصولی یافت نشد!</p>
          </b-col>
        </form>
      </div>
    </b-modal>

    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white d-block my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {productName, subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "FormProductInput",
  props: {
    item: {}
  },
  data() {
    return {
      searchOnProduct: '',
      product_info: null
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
    }),
    generateHashComputed() {
      return generateHash()
    },
  },
  methods: {
    formatNumber,
    productName,
    subProducts,
    ensureConfig() {
      if (!this.item.config) {
        this.$set(this.item, 'config', {})
      }
    },
    toggleSkipAddress(value) {
      this.ensureConfig()
      this.$set(this.item.config, 'skip_address', value)
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    },
    searchProducts() {
      if (this.searchOnProduct.trim() !== '') {
        this.$store.commit('Product/setFilters', {key: 'search', value: this.searchOnProduct})
        this.$store.commit('Product/setFilters', {key: 'is_digital', value: ''})
        this.$store.dispatch('Product/filteredProducts');
      }
    },
    addProduct(subProduct, product) {
      this.item['product_slug'] = product.raw_link
      this.$refs[`choose-product-${this.item.id}`].hide()
      this.loadProductInfo()
    },
    async loadProductInfo() {
      let itemLink = this.item['product_slug'];
      if (itemLink != null) {

        let product = await this.$store.dispatch('Product/getProductWithoutState', itemLink)
        this.product_info = product.data.data;

      }
    }
  },
  mounted() {
    this.ensureConfig()
    this.loadProductInfo()
  }
}
</script>

<style scoped>
.cursor_pointer {
  cursor: pointer;
}

.selected_item {
  background-color: var(--secondary);
  color: white;
}


.overflow-manager {
  height: 250px;
  overflow-y: auto;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


</style>